let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("7CI0R")).then(() => parcelRequire('7oLij'));